import React, { useState } from 'react';

import { Form, Input, Typography } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  handleTokenApi: (tokenApi: string) => void;
  loading: boolean;
  tokenApi: string;
}

function ApiTokenForm({ handleTokenApi, tokenApi, loading }: IProps) {
  const [hasToken, setHasToken] = useState(false);

  return (
    <>
      <Typography.Link onClick={() => setHasToken(!hasToken)}>
        {'Configurações de API de Conversões  '}
        {hasToken ? <Icon.ChevronUp size={16} /> : <Icon.ChevronDown size={16} />}
      </Typography.Link>
      {hasToken && (
        <>
          <div className='mt-4' />
          <Form.Item label='Token API de Conversão'>
            <Input
              size='small'
              disabled={loading}
              value={tokenApi}
              className='w-full'
              onChange={(e: any) => handleTokenApi(e.target.value)}
            />
          </Form.Item>
          <Typography.Paragraph type='secondary'>
            Dentro das configurações do seu Pixel do Facebok, vá na aba{' '}
            <Typography.Text strong>Configurações</Typography.Text> e em{' '}
            <Typography.Text strong>API de Conversões</Typography.Text>, dentro da sessão{' '}
            <Typography.Text strong>Configurar Manualmente</Typography.Text>, clique em{' '}
            <Typography.Text strong>Gerar Token de Acesso</Typography.Text>.
          </Typography.Paragraph>
        </>
      )}
    </>
  );
}

export default React.memo(ApiTokenForm);
